export type ConversationDraft = {
  topic: string;
  background: string;
  expectation: string;
  note: string;
};

export const conversationDraftChecklist = [
  '主题背景',
  '当前情况',
  '期望结果',
  '参考资料或截图',
  '补充说明',
];

export function createConversationDraft(): ConversationDraft {
  return {
    topic: '',
    background: '',
    expectation: '',
    note: '',
  };
}

function valueOrTodo(value: string) {
  const trimmed = value.trim();
  return trimmed || '待补充';
}

export function composeConversationMessage(targetName: string, draft: ConversationDraft) {
  return [
    '【会话说明】',
    `发送给：${targetName || '平台用户'}`,
    `主题/事由：${valueOrTodo(draft.topic)}`,
    `背景说明：${valueOrTodo(draft.background)}`,
    `期望结果：${valueOrTodo(draft.expectation)}`,
    `补充说明：${valueOrTodo(draft.note)}`,
    '',
    '说明要点：',
    ...conversationDraftChecklist.map((item) => `- ${item}`),
    '后续会继续补充图片、语音或文件。',
  ].join('\n');
}
